import styled from "styled-components";

const Text = styled.p`
  color: var(--primary-text);
  text-align: start;
  display: inline;
`;

export default Text;
